import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEmailPendingVerificationBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26.6667 26.6667",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Ellipse",
			filter: "url(#filter0_ii_badge)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M26.6667 13.3333C26.6667 20.6971 20.6971 26.6667 13.3333 26.6667C5.96954 26.6667 0 20.6971 0 13.3333C0 5.96954 5.96954 0 13.3333 0C20.6971 0 26.6667 5.96954 26.6667 13.3333Z",
				fill: "#99C1FD",
				fillOpacity: .5
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M13.0949 5.8829C13.5539 5.8829 13.9261 6.25502 13.9261 6.71405V14.8884L18.9487 17.5572C19.3541 17.7725 19.5082 18.276 19.2928 18.6813C19.0774 19.0865 18.574 19.2408 18.1687 19.0255L13.0292 16.295C12.5582 16.0448 12.2638 15.5548 12.2638 15.0215V6.71405C12.2638 6.25502 12.6359 5.8829 13.0949 5.8829Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_ii_badge",
		x: -18.6667,
		y: -18.6667,
		width: 64,
		height: 64,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: -3.32461 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "arithmetic",
				k2: -1,
				k3: 1
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "shape",
				result: "effect1_innerShadow_badge"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 2.66667,
				dy: 5.33333
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "arithmetic",
				k2: -1,
				k3: 1
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "effect1_innerShadow_badge",
				result: "effect2_innerShadow_badge"
			})
		]
	}) })]
});
export default SvgIconEmailPendingVerificationBadge;
